import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createBlock(_component_button_dropdown, {
    icon: "fas fa-ellipsis-h",
    class: "max-w-min"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: `/cities/update/${_ctx.city.id}`
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "text small" }, {
            default: _withCtx(() => [
              _createTextVNode(" Редактировать ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_the_button, {
        class: "red text small",
        onClick: _ctx.onDelete
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Удалить ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}